/**
 * Formats git metadata for the version stamp shown on Profile.
 * Short hash is the first 7 characters of the full commit hash.
 */
export function formatVersionStamp(branch: string, commitHash: string, commitCount: string): string {
  const shortHash = commitHash.substring(0, 7);
  return `${branch}${shortHash.length > 0 ? `/${shortHash}` : ""} | ${commitCount}`;
}

/**
 * Formats git metadata for the version stamp shown on Profile.
 * Short hash is the first 7 characters of the full commit hash.
 */
export function formatVersionStampWithBranch(_branch: string, commitHash: string, commitCount: string): string {
  const shortHash = commitHash.substring(0, 7);
  return `${shortHash.length > 0 ? `Version ${shortHash}` : ""} | ${commitCount}`;
}

/**
 * Subtle git version stamp (branch, short hash, commit count).
 * Values are read from git at Vite build time so hosted builds can be identified
 * without checking dashboards.
 *
 * @example
 * ```tsx
 * <VersionStamp />
 * ```
 */
export default function VersionStamp() {
  return (
    <output
      className="pointer-events-none font-mono text-[8px] text-gray-400"
      data-testid="version-stamp"
      aria-label="Version stamp"
    >
      {formatVersionStampWithBranch(__BRANCH__, __COMMIT_HASH__, __COMMIT_COUNT__)}
    </output>
  );
}
